











import {ChartDataTemplate, FusionDisplayConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {bus} from "@/main"
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "CompleteAuditScore",
      title: "Complete audit score",
      params: {
        auditCategory: {...WParamTpl.auditCategory(), _order: 1},
      },
      fusionChartParams: {
        numberFormatting: {...FusionDisplayConfTpl.numberFormatting()},
      },
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        showLegend: "0",
        subCaption: "Last 12 months",
        paletteColors: '#6baa01, #DC143C',
        showLabels: "1",
        labelDisplay: "$label , $value",
        showZeroPies: "1",
        showPercentValues: "1",
        showPercentInTooltip: "1",
        enableSlicing: "0",
        animation: "0",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Category: " + config.params.auditCategory.value.title
    }
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
      const toDate = getTodayYYYYMMDD()

      context.emit("config-update", config())

      async function dataFetcher(params: any) {
        return {
          data: await executeQuery("micad4-audit", "completeAuditScore",
                  {fromDate, toDate, categoryID: params.auditCategory.value.value})
        }
      }

      function dataplotClickCallback(label: string, val: any, data?: any) {
        if (val === undefined) {
          return
        }
        const params = props.config && props.config.params
        console.info("label:", label, "val:", val, "data:", data)
        bus.$emit('chartPopup', {
          title: 'Complete Audit Score (' + label + ': ' + val + ')',
          component: () => import('@/components/widgets/audit/AuditCompleteAuditScoreDrillDown.vue'),
          componentArgs: {
            fromDate: fromDate,
            toDate: toDate,
            passFail: (label === "Pass") ? 1 : 0,
            categoryId: params.auditCategory.value.value,
          },
        })
      }

      return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
